module.exports = __webpack_public_path__ + "static/media/personInfo.d4078194.svg";